import React, { Suspense, useEffect, useState } from "react";
import { connect } from "react-redux";
import jwt_decode from "jwt-decode";
import { Routes, Route, Navigate } from "react-router-dom";
import { IntlProvider } from "react-intl";
import AlertToken from "./components/ModalAlert/AlertToken";
import { useSelector } from "react-redux";
import AppLocale from "./lang";
import { NotificationContainer } from "./components/common/react-notifications";
import { Spin } from "antd";
import "react-photo-view/dist/react-photo-view.css";

const ViewApp = React.lazy(() =>
  import(/* webpackChunkName: "views-app" */ "./views/app")
);
const ViewUser = React.lazy(() =>
  import(/* webpackChunkName: "views-user" */ "./views/user")
);

const App = (props) => {
  const [showAlert, setShowAlert] = useState(false);
  const token = useSelector((state) => state.AuthenSlice.token);

  const { locale } = props;
  const currentAppLocale = AppLocale[locale];
  const contentStyle = {
    padding: 50,
    background: "rgba(0, 0, 0, 0.05)",
    borderRadius: 4,
  };
  const content = <div style={contentStyle} />;

  useEffect(() => {
    if (!token) return;

    const decoded = jwt_decode(token);
    const now = Math.floor(Date.now() / 1000);

    if (now >= decoded.exp) {
      setShowAlert(true);
      return;
    }

    const interval = setInterval(() => {
      const t = Math.floor(Date.now() / 1000);
      if (t >= decoded.exp) {
        setShowAlert(true);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [token]);

  return (
    <div className="h-100">
      <IntlProvider
        locale={currentAppLocale?.locale}
        messages={currentAppLocale?.messages}
      >
        <NotificationContainer />

        <Suspense
          fallback={
            <div
              style={{
                height: "100vh",
                width: "100%",
                alignItems: "center",
              }}
              className="d-flex justify-content-center"
            >
              <Spin
                // tip={intl.formatMessage({ id: "wait" })}
                size="large"
                style={{ height: "100%", width: "100%" }}
              >
                {content}
              </Spin>
            </div>
          }
        >
          <Routes>
            <Route path="/user/*" element={<ViewUser />} />

            {token ? (
              <Route path="/app/*" element={<ViewApp />} />
            ) : (
              <Route
                path="/user/*"
                element={<Navigate to="/user/login" replace />}
              />
            )}

            <Route
              path="/"
              element={<Navigate to={token ? "/app" : "/user/login"} replace />}
            />

            {/* <Route>
              <div
                style={{
                  padding: 50,
                  textAlign: "center",
                  fontSize: 22,
                  fontWeight: "bold",
                }}
              >
                404 | Page Not Found
              </div>
            </Route> */}
          </Routes>
        </Suspense>

        {showAlert && (
          <AlertToken
            show={showAlert}
            close={() => {
              setShowAlert(false);
              window.location.href = "/user/login";
            }}
          />
        )}
      </IntlProvider>
    </div>
  );
};

const mapStateToProps = ({ settings }) => {
  const { locale } = settings;
  return { locale };
};

export default connect(mapStateToProps)(App);
